import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "datatables.net-react";
import DT from "datatables.net-bs5";

import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-buttons-bs5/css/buttons.bootstrap5.min.css";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css"; // Responsive CSS

import "datatables.net-bs5";
import "datatables.net-buttons-bs5";
import "datatables.net-responsive-bs5"; // Responsive JS
import "datatables.net-buttons/js/buttons.html5.min.js";
import "datatables.net-buttons/js/buttons.print.min.js";
import "datatables.net-buttons/js/buttons.colVis.min.js";
import "jszip";
import "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";
import "../Vendor/VendorLeads/VendorLeadDataTableCSS.css";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../../../Store/AuthContext";

DataTable.use(DT);

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function LeadTransactionDetailsDataTable({ leadid }) {
  const { userID, RendomTokenfetch } = useAuth();
  const navigate = useNavigate();
  const [TransactionDataCount, setTransactionDataCount] = useState([]);
  // const [TransactionData, setTransactionData] = useState([]);
  // console.log(TransactionData);
  // *********** DataTable Coulmns *********
  const columns = [
    {
      title: "Order Id",
      data: "order_id",
    },
    {
      title: "Receipt Id",
      data: "receipt_id",
    },
    {
      title: "Payment Mode",
      data: "payment_mode",
    },
    {
      title: "Type",
      data: "credit_debit",
      render: (data, type, row) => {
        let requSts = "";
        if (data === "1") {
          requSts = `<span class="badge bg-info">
                                  Credit
                                </span>`;
        } else {
          requSts = `<span class="badge bg-danger">
                                  Debit
                                </span>`;
        }

        return `${requSts}`;
      },
    },
    {
      title: "Amount",
      data: "amount",
      render: (data, type, row) => {
        return `<span class="text-primary">₹ ${data}</span>`;
      },
    },

    {
      title: "Paid Status",
      data: "paid_type",
      render: (data, type, row) => {
        let requSts = "";
        if (data === "1") {
          requSts = `<span class="badge bg-success">
                                  Paid
                                </span>`;
        } else if (data === "2") {
          requSts = `<span class="badge bg-warning">
                                  Cancel
                                </span>`;
        } else {
          requSts = `<span class="badge bg-danger">
                                  Unpaid
                                </span>`;
        }

        return `${requSts}`;
      },
    },
    { title: "Date", data: "date" },

    {
      title: "Action",
      data: "id",
      createdCell: (td, cellData, rowData) => {
        // Start with empty HTML
        td.innerHTML = "";

        // View Button
        const viewBtn = document.createElement("button");
        viewBtn.className = "newspaperviewbtn me-1";
        viewBtn.title = "View";
        viewBtn.innerHTML = `<i class="fa fa-eye" aria-hidden="true"></i>`;
        viewBtn.onclick = () => {
          navigate(`/single-leadtransaction-details/${rowData.order_id}`);
        };
        td.appendChild(viewBtn);

        // Conditionally show Update Button only if vender_status === "1"
        if (rowData.paid_type === "0" && rowData.paymentlink) {
          const updateBtn = document.createElement("button");
          updateBtn.className = "newspaperSnedbtn";
          updateBtn.title = "Send Payment Link";
          updateBtn.innerHTML = `<i class="fa fa-paper-plane" aria-hidden="true"></i>`;
          updateBtn.onclick = () => {
            window.location.href = rowData.paymentlink;
            // navigate(`${rowData.paymentlink}`);
          };
          td.appendChild(updateBtn);
        }
      },

      // render: (data, type, row) => {
      //   const viewBtn = `<a href="/single-transaction-details/${row.id}" class="lead-link newspaperEditbtn"><i class="fa fa-eye" aria-hidden="true"></i></a>`;

      //   const SendBtn =
      //     row.paid_type === "0" && row.paymentlink
      //       ? `<a href="${row.paymentlink}" target="_blank" rel="noopener noreferrer" class="newspaperSnedbtn" title="Send Payment Link"><i class="fa fa-paper-plane-o"></i></a>`
      //       : "";

      //   return `${viewBtn} ${SendBtn}`;
      // },
    },
  ];

  useEffect(() => {}, [navigate, userID, RendomTokenfetch]);

  return (
    <>
      {/* *******************Count Total Status************** */}
      <div className="row">
        <div className="ui-block col-xl-3 col-lg-4 col-md-6 col-sm-12">
          <div className="ui-item ui-primary">
            <div className="left">
              <i className="icon fa fa-inr"></i>
            </div>
            <div className="right">
              <h4>₹{TransactionDataCount?.finalamount || 0}</h4>
              <p>Final Amount</p>
            </div>
          </div>
        </div>
        <div className="ui-block col-xl-3 col-lg-4 col-md-6 col-sm-12">
          <div className="ui-item ui-green">
            <div className="left">
              <i className="icon fa fa-check-square-o"></i>
            </div>
            <div className="right">
              <h4>₹{TransactionDataCount?.recievedamount || 0}</h4>
              <p>Received Amount</p>
            </div>
          </div>
        </div>

        <div className="ui-block col-xl-3 col-lg-4 col-md-6 col-sm-12">
          <div className="ui-item ui-yellow">
            <div className="left">
              <i className="icon fa fa-retweet"></i>
            </div>
            <div className="right">
              <h4>₹{TransactionDataCount?.returnamount || 0}</h4>
              <p>Return Amount</p>
            </div>
          </div>
        </div>
        <div className="ui-block col-xl-3 col-lg-4 col-md-6 col-sm-12">
          <div className="ui-item ui-red">
            <div className="left">
              <i className="icon fa fa-clock-o"></i>
            </div>
            <div className="right">
              <h4>₹{TransactionDataCount?.pendingamount || 0}</h4>
              <p>Panding Amount</p>
            </div>
          </div>
        </div>
      </div>

      {/* ************Data Table Rows ************* */}
      <div className="row">
        <div className="col-lg-12">
          <div className="ls-widget mb-0">
            <div className="tabs-box"></div>
            <div
              className="widgetcontent p-3 table-responsive"
              style={{ overflowX: "auto" }}
            >
              <DataTable
                className="table table-striped table-bordered vendordatatable"
                columns={columns}
                responsive={true}
                noHeader={true}
                style={{ tableLayout: "auto", width: "100%" }}
                processing={true}
                options={{
                  responsive: false,
                  ordering: false,
                  scrollX: true,
                  dom: "Bfrtip",

                  buttons: [
                    {
                      extend: "copy",
                      text: `<i class="fa fa-clone"></i>`,
                      className: "btn btn-sm",
                      titleAttr: "Copy to clipboard",
                      exportOptions: {
                        columns: ":visible",
                      },
                    },
                    {
                      extend: "excelHtml5",
                      text: `<i class="fa fa-file-excel-o"></i>`,
                      className: "btn btn-sm",
                      titleAttr: "Export to Excel",
                      exportOptions: {
                        columns: ":visible",
                      },
                    },
                    {
                      extend: "pdfHtml5",
                      text: `<i class="fa fa-file-pdf-o"></i>`,
                      className: "btn btn-sm",
                      titleAttr: "Export to PDF",
                      exportOptions: {
                        columns: ":visible",
                      },
                    },
                    {
                      extend: "print",
                      text: '<i class="fa fa-print"></i>',
                      className: "btn btn-sm",
                      titleAttr: "Print table",
                      exportOptions: {
                        columns: ":visible",
                        modifier: {
                          page: "all",
                        },
                      },
                    },
                    {
                      extend: "colvis",
                      text: "Column Visibility", // Boxicon for Column Visibility
                      className: "btn btn-sm",
                      titleAttr: "Toggle column visibility",
                    },
                    {
                      extend: "pageLength",
                      text: "Show Rows",
                      className: "btn btn-sm",
                      titleAttr: "Change Number of Rows Displayed",
                    },
                  ],
                  lengthMenu: [
                    [10, 50, 100, 150, 200, -1],
                    [10, 50, 100, 150, 200, "All"],
                  ],

                  colVis: {
                    restore: true,
                  },

                  stateSave: true,
                  deferRender: true,
                  scrollCollapse: true,
                  scroller: true,
                  pagingType: "full_numbers",
                  fixedHeader: true,
                  autoWidth: false,
                  serverSide: true,
                  paging: true,
                  pageLength: 10,
                  ajax: (data, callback) => {
                    const page = Math.floor(data.start / data.length) + 1;
                    const limit = data.length;

                    axios
                      .get(`${WebsiteAPIurl}lead_transaction`, {
                        params: {
                          user_id: userID,
                          leadid: leadid,
                          page: page,
                          limit: limit,
                          search: data.search.value,
                        },
                        headers: { Authorization: RendomTokenfetch },
                      })
                      .then((res) => {
                        const r = res.data;
                        // console.log(res.data);
                        const total = parseInt(r.totalcount) || 0;
                        // const data = Array.isArray(r.transactions)
                        //   ? r.transactions
                        //   : [];

                        // setTransactionData(data);
                        setTransactionDataCount(res.data.leadamountcount);

                        callback({
                          data: r.transactions,
                          recordsTotal: total,
                          recordsFiltered: total,
                        });
                      })
                      .catch(() =>
                        callback({
                          data: [],
                          recordsTotal: 0,
                          recordsFiltered: 0,
                        })
                      );
                  },
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
